import { cva, type VariantProps } from "class-variance-authority";

/* Variants */
const variants = cva("loading loading-spinner", {
  variants: {
    size: {
      sm: "loading-sm",
      md: "loading-md",
      lg: "loading-lg",
    },
  },
  defaultVariants: {
    size: "lg",
  },
});

/* Prop Types */
interface LoadingProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof variants> {}

/*
 * Loading component
 * generic loading fallback spinner
 */
export const Loading = ({ size, ...props }: LoadingProps) => {
  return (
    <div className="flex flex-col grow w-full h-full items-center justify-center" {...props}>
      <span className={variants({ size })}></span>
    </div>
  );
};
